"use client"

import { Button } from "@/components/ui/button"
import { cn } from "@/lib/utils"
import { Menu, X } from "lucide-react"
import Link from "next/link"
import { useEffect, useState } from "react"
import { Logo } from "./logo"

export function Nav() {
	const [scrolled, setScrolled] = useState(false)
	const [mobileOpen, setMobileOpen] = useState(false)

	useEffect(() => {
		function handleScroll() {
			setScrolled(window.scrollY > 20)
		}
		window.addEventListener("scroll", handleScroll)
		return () => window.removeEventListener("scroll", handleScroll)
	}, [])

	// Close mobile menu on resize to desktop
	useEffect(() => {
		function handleResize() {
			if (window.innerWidth >= 768) {
				setMobileOpen(false)
			}
		}
		window.addEventListener("resize", handleResize)
		return () => window.removeEventListener("resize", handleResize)
	}, [])

	return (
		<nav
			className={cn(
				"sticky top-0 z-50 transition-all duration-300",
				scrolled || mobileOpen
					? "border-b border-[var(--border-dim)] backdrop-blur-xl bg-[var(--bg-void)]/80"
					: "border-b border-transparent bg-transparent",
			)}
		>
			<div className="flex items-center justify-between px-6 py-4 max-w-6xl mx-auto">
				<Logo />

				{/* Desktop nav */}
				<div className="hidden md:flex items-center gap-8">
					<Link
						href="/features"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Features
					</Link>
					<Link
						href="/docs"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Docs
					</Link>
					<Link
						href="/pricing"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Pricing
					</Link>
					<Link
						href="/blog"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Blog
					</Link>
					<Link
						href="/demo"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Demo
					</Link>
					<Link
						href="/login"
						className="text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] transition-colors"
					>
						Login
					</Link>
					<Button asChild className="glow-button">
						<Link href="/register">Start Free</Link>
					</Button>
				</div>

				{/* Mobile menu button */}
				<button
					type="button"
					className="md:hidden p-2 text-[var(--text-gray)] hover:text-[var(--text-white)]"
					onClick={() => setMobileOpen(!mobileOpen)}
					aria-label={mobileOpen ? "Close menu" : "Open menu"}
				>
					{mobileOpen ? (
						<X className="h-6 w-6" />
					) : (
						<Menu className="h-6 w-6" />
					)}
				</button>
			</div>

			{/* Mobile nav */}
			{mobileOpen && (
				<div className="md:hidden border-t border-[var(--border-dim)] bg-[var(--bg-void)]/95 backdrop-blur-xl">
					<div className="flex flex-col gap-1 p-4">
						<Link
							href="/features"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Features
						</Link>
						<Link
							href="/docs"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Docs
						</Link>
						<Link
							href="/pricing"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Pricing
						</Link>
						<Link
							href="/blog"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Blog
						</Link>
						<Link
							href="/demo"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Demo
						</Link>
						<Link
							href="/login"
							className="px-4 py-3 text-sm text-[var(--text-gray)] hover:text-[var(--text-white)] hover:bg-[var(--bg-card)] rounded-lg transition-colors"
							onClick={() => setMobileOpen(false)}
						>
							Login
						</Link>
						<div className="pt-2">
							<Button asChild className="glow-button w-full">
								<Link href="/register" onClick={() => setMobileOpen(false)}>
									Start Free
								</Link>
							</Button>
						</div>
					</div>
				</div>
			)}
		</nav>
	)
}
